export enum CommunicationsResponseGetConferenceParticipantsError {
  unableToGetConferenceParticipants = 'unableToGetConferenceParticipants',
}
